import React, { useState } from 'react';
import './SupplierSelectorModal.css';

const SupplierSelectorModal = ({ onClose, onSelect }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [suppliers, setSuppliers] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchSuppliers = async () => {
        if (!searchTerm.trim()) return;
        setLoading(true);
        try {
            const res = await fetch(`/api/fornecedores?search=${encodeURIComponent(searchTerm)}&fields=NomeEmpresa`);
            if (res.ok) {
                const data = await res.json();
                setSuppliers(data);
            }
        } catch (error) {
            console.error('Erro ao buscar fornecedores:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content supplier-selector-modal">
                <div className="win-title">
                    Selecionar Fornecedor
                    <button className="btn-close" onClick={onClose}>×</button>
                </div>
                <div className="win-body">
                    <div className="search-box">
                        <input
                            type="text"
                            placeholder="Buscar fornecedor por nome..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && fetchSuppliers()}
                            autoFocus
                        />
                        <button className="btn-classic" onClick={fetchSuppliers}>Buscar</button>
                    </div>

                    <div className="selector-list">
                        {loading ? <p style={{ padding: '10px' }}>Buscando...</p> :
                            suppliers.length === 0 ? (
                                <p style={{ padding: '10px' }}>
                                    {searchTerm ? 'Nenhum fornecedor encontrado.' : 'Digite um nome para pesquisar.'}
                                </p>
                            ) : (
                                suppliers.map(s => (
                                    <div key={s.ID} className="selector-item" onClick={() => onSelect(s)}>
                                        <strong>{s.NomeEmpresa}</strong>
                                        <span>ID: #{s.ID}</span>
                                    </div>
                                ))
                            )
                        }
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="btn-classic danger" onClick={onClose}>Cancelar</button>
                </div>
            </div>
        </div>
    );
};

export default SupplierSelectorModal;
